export default function offerLabelsOptionsResolver({ offer, itemSettings }) {
    return {
        bind: {
            offer,
            settings: itemSettings,
        },
    };
}